/**
 * Generator that yields items from an iterator as [prev, item, next], where
 * the center item will visit each element in the iterator, but prev will be
 * nullish on the first value, and next will be nullish on the last value.
 */
export function* neighbors<T>(iterable: Iterable<T>): Generator<[T | undefined, T, T | undefined]> {
    const iter = iterable[Symbol.iterator]();
    let
        prev = iter.next(), curr = iter.next(), next = iter.next();
    if (prev.done) return;

    yield [null, prev.value, curr.value];

    while (!curr.done) {
        yield [prev.value, curr.value, next.value];
        prev = curr;
        curr = next;
        next = iter.next();
    }
}
